<template>
    <div class="adjustment-container">
        <TagsCloud ref="cloudtage" @cloudTages="cloudTages" />
        <div class="project-table">
            <avue-crud
                :option="tableConfig"
                :data="tableData"
                v-model="searchForm"
                :page.sync="page"
                :search.sync="searchForm"
                @search-reset="searchReset"
                @on-load="queryTableData"
                @search-change="searchChange"
                @sort-change="sortChange"
                @refresh-change="queryTableData"
                @selection-change="selectionChange"
            >
                <template slot="searchMenu" slot-scope="{ row }">
                    <el-button type="primary" @click="save(row)">保存</el-button>
                    <!-- <el-button type="primary"  @click="openFilter">
                        <a-icon type="filter" /> 高级筛选
                    </el-button> -->
                </template>

                <template slot="menuLeft">
                    <el-button
                        type="primary"
                        size="small"
                        icon="el-icon-plus"
                        @click.stop="handleAdd()"
                    >
                        新增项目调整
                    </el-button>
                    <el-button
                        type="primary"
                        size="small"
                        plain
                        icon="el-icon-edit"
                        @click.stop="handleEdit()"
                    >
                        编辑
                    </el-button>                    
                    <el-button
                        size="small"
                        icon="el-icon-download"
                        @click="exportShow"
                    >导出数据
                    </el-button>
                </template>
                <template slot="sellerCustNameSearch">
                    <CommonSelect
                        bindLabel="dictValue"
                        bindKey="dictKey"
                        bindValue="dictValue"
                        dataUrl="/blade-/zd/custom/dict"
                        @handleChange="setSellerCustId"
                    />
                </template>
                <template slot="name" slot-scope="{ row }">
                    <div class="project-name" @click="goDetail(row)">{{row.name}}</div>
                </template>
            </avue-crud>
        </div>

        <el-drawer
            title="高级筛选"
            :visible.sync="drawer"
            size="60%"
            custom-class="drawer_wrapper"
            :with-header="false"
        >
            <div class="drawer_screen_wrapper">
                <div class="screen_header">
                    <div class="screen_header_name">
                        <a-icon type="filter" />
                        高级筛选
                    </div>
                    <div class="screen_header_remarks" @click="drawer = false">
                        <i class="el-icon-video-play"></i>
                        收起
                    </div>
                </div>
                <div class="screen_content">
                    <avue-form
                        :option="filterConfig"
                        ref="formScreen"
                        v-model="searchForm"
                        @submit="filterSearch"
                        @reset-change="searchResetScreen"
                    >
                        <template slot="factoringCredit">
                            <div class="form_slot">
                                <el-input-number
                                    v-model="searchForm.factoringCreditMin"
                                    :controls="false"
                                    placeholder="开始数值"
                                    style="width: 100%"
                                />
                                &nbsp;~&nbsp;
                                <el-input-number
                                    v-model="searchForm.factoringCreditMin"
                                    :controls="false"
                                    placeholder="结束数值"
                                    style="width: 100%"
                                />
                            </div>
                        </template>
                    </avue-form>
                </div>
            </div>
        </el-drawer>

        <SelectPerson
            ref="selectperson"
            :checkUserList="checkUserList"
            :isOnly="true"
            :clear="false"
            @setPeople="setPeople"
        />

        <SelectDepartment
            ref="selectdepartment"
            :checkdepartment="checkdepartment"
            :isOnly="true"
            @setDepartment="setDepartment"
        />
        
        <ExportData ref="exportData" @exportDownload="exportDownload" />
    </div>
</template>
<script>
import TagsCloud from "@/components/TagsCloud/TagsCloud"
import ExportData from "@/components/exportData/exportData"
import SelectPerson from "@/components/SelectPersonnel/person";
import SelectDepartment from "@/components/SelectDepartment/department";
import CommonSelect from "@/components/commonSelect/commonSelect"
import commonList from "@/mixins/list"
import { adjustmentListConfig, adjustmentFilterConfig } from './adjustmentConfig.js'
import {queryAdjustmentList} from "@/api/factoring/factoring"
import moment from "moment";
export default {
    name: 'ProjectAdjustment',
    mixins: [commonList],
    data() {
        return {
            drawer: false,
            tableData: [],
            searchForm: {},
            tableConfig: adjustmentListConfig(this.getMoney, this.selectPersonClick,this.selectDeptClick),
            filterConfig: adjustmentFilterConfig(this.selectPersonClick,this.selectDeptClick),
        }
    },
    components: {
        TagsCloud,
        SelectPerson,
        SelectDepartment,
        CommonSelect,
        ExportData
    },    
    mounted() {
        let setParams = {

        }
        this.setCommonParams(setParams)
        // 设置导出链接
        this.setExportUrl('/api/bl/blprojectadjust/export')
    },
    methods: {
        handleAdd() {
            this.$router.push({
                path: `/factoring/projectAdjustment/addAdjustment`
            })
        },
        goDetail(row) {
            this.$router.push({
                path: `/factoring/projectAdjustment/adjustmentDetail/${row.id}`
            })
        },

        setSellerCustId(data) {
            this.searchForm.sellerCustId = data.dictKey
            this.searchForm.sellerCustName = data.dictValue
        },        

        async queryTableData() {
            let params = {
                current: this.page.currentPage,
                size: this.page.pageSize,
                ...this.searchForm,
                createDateBegin: this.searchForm.timePic&&this.searchForm.timePic.length>0
                ? moment(this.searchForm.timePic[0]).format("YYYY-MM-DD")
                : undefined,
                createDateEnd: this.searchForm.timePic&&this.searchForm.timePic.length>0
                ? moment(this.searchForm.timePic[1]).format("YYYY-MM-DD")
                : undefined,
            }
            let res = await queryAdjustmentList(params)
            if(res.data.code == 200) {
                this.tableData = res.data.data.records
                this.page.total = res.data.data.total
            }else {
                this.$message.error(res.data.msg)
            }
        }    
    }
}
</script>
<style lang="scss" scoped>
.adjustment-container{
  .topcrud {
    line-height: 45px;
    font-size: 18px;
    background: #f9f9f9;
    border-radius: 15px 15px 0 0;
    text-indent: 25px;
    // margin: 0 5px;
    border-bottom: 1px solid #e9e9e9;
    .messagetitle {
      font-weight: bolder;
    }
  }
  .project-table {
    background: #ffff;
    padding: 25px;
  }
  .project-name{
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
    color: #409EFF;
  }
  .project-name:hover{
    color: #409EFF;
    cursor: pointer;
  }    
}
</style>